/**
 * useOnline — reports `navigator.onLine` and keeps the value in sync
 * via the online/offline window events. Falls back to `true` during
 * SSR / jsdom runs where the property is undefined.
 */
import { useEffect, useState } from 'react';

function currentOnline(): boolean {
  if (typeof navigator === 'undefined' || typeof navigator.onLine !== 'boolean') return true;
  return navigator.onLine;
}

export function useOnline(): boolean {
  const [online, setOnline] = useState<boolean>(currentOnline());

  useEffect(() => {
    const handleOn = () => setOnline(true);
    const handleOff = () => setOnline(false);
    window.addEventListener('online', handleOn);
    window.addEventListener('offline', handleOff);
    return () => {
      window.removeEventListener('online', handleOn);
      window.removeEventListener('offline', handleOff);
    };
  }, []);

  return online;
}
